import { useEffect, useState, useCallback } from 'react';
import { getAiModels } from '@editor2/services/apiService';
import { type AiModel } from '@editor2/types/aiModel';

// Coalesce requests from chatboxes mounted together without caching the catalog indefinitely.
let pendingRequest: ReturnType<typeof getAiModels> | undefined;
const loadModels = () => {
	if (!pendingRequest) {
		pendingRequest = getAiModels().finally(() => {
			pendingRequest = undefined;
		});
	}
	return pendingRequest;
};

export const useAiModels = (enabled = true) => {
	const [models, setModels] = useState<AiModel[] | null>(null);
	const [error, setError] = useState(false);
	const [attempt, setAttempt] = useState(0);
	const retry = useCallback(() => {
		setModels(null);
		setError(false);
		setAttempt((value) => value + 1);
	}, []);

	useEffect(() => {
		if (!enabled) return;
		let active = true;
		setModels(null);
		setError(false);
		loadModels().then(
			({ data }) => {
				if (active) setModels(data.models);
			},
			() => {
				if (active) setError(true);
			}
		);
		return () => {
			active = false;
		};
	}, [enabled, attempt]);

	return { models, error, loading: enabled && models === null && !error, retry };
};
